/* KALANK storefront v8.2 — lightweight, dependency-free */
(function () {
  'use strict';
  var d = document, reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* header scroll state */
  var ticking = false;
  function sync() { d.body.classList.toggle('kalank-scrolled', window.scrollY > 18); ticking = false; }
  window.addEventListener('scroll', function () { if (!ticking) { requestAnimationFrame(sync); ticking = true; } }, { passive: true });
  sync();

  /* announcement rotation */
  d.querySelectorAll('[data-kalank-rotate]').forEach(function (bar) {
    var items = bar.querySelectorAll('.KAnnounce__Item'); if (items.length < 2 || reduce) return;
    var i = 0, delay = (parseInt(bar.getAttribute('data-kalank-rotate'), 10) || 5) * 1000;
    setInterval(function () { if (d.hidden) return; items[i].classList.remove('is-active'); i = (i + 1) % items.length; items[i].classList.add('is-active'); }, delay);
  });

  /* clicks: row arrows + quick add */
  d.addEventListener('click', function (e) {
    var rb = e.target.closest('[data-krow]');
    if (rb) { var t = rb.closest('.KRow').querySelector('[data-krow-track]'); if (t) t.scrollBy({ left: (parseInt(rb.getAttribute('data-krow'), 10) || 1) * Math.max(280, t.clientWidth * .78), behavior: reduce ? 'auto' : 'smooth' }); return; }
    var btn = e.target.closest('[data-kalank-quick-add]'); if (!btn) return;
    e.preventDefault(); e.stopPropagation(); if (btn.classList.contains('is-loading')) return;
    btn.classList.add('is-loading');
    fetch('/cart/add.js', { method: 'POST', credentials: 'same-origin', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json', 'X-Requested-With': 'XMLHttpRequest' }, body: JSON.stringify({ items: [{ id: parseInt(btn.getAttribute('data-kalank-quick-add'), 10), quantity: 1 }] }) })
      .then(function (r) { btn.classList.remove('is-loading'); if (!r.ok) { btn.classList.add('is-error'); return; } btn.classList.add('is-added'); refreshCount(); d.dispatchEvent(new CustomEvent('product:added', { bubbles: true, detail: { variant: { id: btn.getAttribute('data-kalank-quick-add') }, quantity: 1 } })); setTimeout(function () { btn.classList.remove('is-added'); }, 1700); })
      .catch(function () { btn.classList.remove('is-loading'); });
  }, true);
  d.querySelectorAll('[data-krow-track]').forEach(function (t) {
    var row = t.closest('.KRow'), p = row.querySelector('[data-krow="-1"]'), n = row.querySelector('[data-krow="1"]');
    function u() { if (!p) return; p.disabled = t.scrollLeft < 8; n.disabled = t.scrollLeft + t.clientWidth > t.scrollWidth - 8; }
    t.addEventListener('scroll', u, { passive: true }); u();
  });

  /* PDP: purchase path first — descriptor (mobile), delivery, trust lines + accordions sit below the buy buttons */
  var form = d.querySelector('.Product__Info .ProductForm');
  if (form) {
    var anchor = form;
    if (window.innerWidth < 1008) { var desc = d.querySelector('.Product__Info .KMeta__Descriptor'); if (desc) { form.parentNode.insertBefore(desc, form.nextSibling); anchor = desc; } }
    ['.KDelivery', '.KTrustLines', '.KAccordions'].forEach(function (s) { var el = d.querySelector('.Product__Info ' + s); if (el) { anchor.parentNode.insertBefore(el, anchor.nextSibling); anchor = el; } });
  }

  /* PDP: mobile gallery counter (1 / 6) */
  var slideshow = d.querySelector('.Product__Slideshow');
  if (slideshow) {
    var slides = slideshow.querySelectorAll('.Product__SlideItem');
    if (slides.length > 1) {
      var counter = d.createElement('div'); counter.className = 'KGalleryCount'; counter.setAttribute('aria-hidden', 'true');
      slideshow.parentNode.appendChild(counter);
      var upd = function () { var idx = 0; slides.forEach(function (s, i) { if (s.classList.contains('is-selected')) idx = i; }); counter.textContent = (idx + 1) + ' / ' + slides.length; };
      upd(); new MutationObserver(upd).observe(slideshow, { subtree: true, attributes: true, attributeFilter: ['class'] });
    }
  }

  /* PDP sticky bag (mobile) */
  var sticky = d.querySelector('[data-kalank-sticky]'), mainBtn = d.querySelector('.Product .ProductForm__AddToCart');
  if (sticky && mainBtn && 'IntersectionObserver' in window) {
    sticky.hidden = false;
    new IntersectionObserver(function (en) { var e = en[0]; sticky.classList.toggle('is-visible', !(e.isIntersecting || e.boundingClientRect.top > window.innerHeight)); }).observe(mainBtn);
    sticky.querySelector('[data-kalank-sticky-btn]').addEventListener('click', function () { if (mainBtn.disabled) { mainBtn.scrollIntoView({ behavior: 'smooth', block: 'center' }); return; } mainBtn.click(); });
  }

  /* Collection filters: group tags into Occasion / Colour / Detail */
  var groups = { 'Occasion': ['wedding','festive','reception','everyday'], 'Colour': ['black','ivory','pink','crimson','gold','green','blue','purple','beige','brown','magenta','wine','olive','yellow','orange','silver','rose','multicolour'] };
  var tagButtons = d.querySelectorAll('[data-action="toggle-tag"]');
  if (tagButtons.length) {
    var lists = []; tagButtons.forEach(function (b) { var ul = b.closest('ul'); if (ul && lists.indexOf(ul) < 0) lists.push(ul); });
    lists.forEach(function (ul) {
      var wrap = ul.closest('.Collapsible'); if (!wrap || wrap.dataset.kGrouped) return;
      var buckets = { 'Occasion': [], 'Colour': [], 'Detail': [] };
      ul.querySelectorAll('li').forEach(function (li) { var b = li.querySelector('[data-tag]'); if (!b) return; var tag = b.getAttribute('data-tag'); var g = groups.Occasion.indexOf(tag) > -1 ? 'Occasion' : groups.Colour.indexOf(tag) > -1 ? 'Colour' : 'Detail'; buckets[g].push(li); });
      var frag = d.createDocumentFragment();
      Object.keys(buckets).forEach(function (name) {
        if (!buckets[name].length) return;
        var c = wrap.cloneNode(false); c.dataset.kGrouped = '1';
        var btn = wrap.querySelector('.Collapsible__Button').cloneNode(true); btn.childNodes[0].nodeValue = name + ' ';
        var inner = d.createElement('div'); inner.className = 'Collapsible__Inner';
        var content = d.createElement('div'); content.className = 'Collapsible__Content';
        var list = d.createElement('ul'); list.className = ul.className;
        buckets[name].forEach(function (li) { list.appendChild(li); });
        content.appendChild(list); inner.appendChild(content); c.appendChild(btn); c.appendChild(inner); frag.appendChild(c);
      });
      wrap.parentNode.insertBefore(frag, wrap); wrap.parentNode.removeChild(wrap);
    });
  }

  /* gentle reveal */
  if ('IntersectionObserver' in window && !reduce) {
    var io = new IntersectionObserver(function (es) { es.forEach(function (e) { if (e.isIntersecting) { e.target.classList.add('is-in'); io.unobserve(e.target); } }); }, { rootMargin: '0px 0px -8% 0px' });
    d.querySelectorAll('.KSectionHead, .KStatement > *, .KOfferSection__Content > *, .KLook__Content > *, .KTriptych__Item, .KInsta__Item').forEach(function (el, i) { el.classList.add('KReveal'); el.style.transitionDelay = (i % 4) * 80 + 'ms'; io.observe(el); });
  }

  /* PDP info panel: sticky that works even when taller than the viewport */
  var pinfo = d.querySelector('.Product__Info');
  if (pinfo) {
    var fitSticky = function () {
      if (window.innerWidth < 1008) { pinfo.style.top = ''; return; }
      var t = Math.min(110, window.innerHeight - pinfo.offsetHeight - 24);
      pinfo.style.setProperty('top', t + 'px', 'important');
    };
    fitSticky(); window.addEventListener('resize', fitSticky); window.addEventListener('load', fitSticky);
    d.addEventListener('toggle', function () { fitSticky(); }, true);
  }

  /* header bag count */
  function syncCount() { d.querySelectorAll('.KHdrCount').forEach(function (c) { c.classList.toggle('is-empty', (parseInt(c.textContent, 10) || 0) === 0); }); }
  function refreshCount() { fetch('/cart.js', { credentials: 'same-origin' }).then(function (r) { return r.json(); }).then(function (c) { d.querySelectorAll('.KHdrCount').forEach(function (el) { el.textContent = c.item_count; }); syncCount(); }).catch(function () {}); }
  d.querySelectorAll('.KHdrCount').forEach(function (c) { new MutationObserver(syncCount).observe(c, { childList: true, characterData: true, subtree: true }); });
  d.addEventListener('cart:refresh', refreshCount);
  syncCount();

  /* search overlay: suggestions vs results */
  var sm = d.getElementById('Search');
  if (sm) {
    var si = sm.querySelector('.Search__Input');
    if (si) si.addEventListener('input', function () { sm.classList.toggle('has-query', si.value.trim().length > 0); });
  }

  /* animated accordions */
  d.querySelectorAll('.KAcc').forEach(function (det) {
    var sum = det.querySelector('summary'), body = det.querySelector('.KAcc__Body');
    if (!sum || !body || reduce) return;
    sum.addEventListener('click', function (e) {
      e.preventDefault(); if (det.dataset.anim) return; det.dataset.anim = '1';
      var clear = function () { body.style.cssText = ''; delete det.dataset.anim; };
      if (det.open) {
        body.style.height = body.scrollHeight + 'px'; body.style.overflow = 'hidden';
        requestAnimationFrame(function () { body.style.transition = 'height .28s cubic-bezier(.22,.61,.36,1), opacity .2s, padding .28s'; body.style.height = '0px'; body.style.opacity = '0'; body.style.paddingBottom = '0px'; });
        setTimeout(function () { det.open = false; clear(); }, 300);
      } else {
        det.open = true; var h = body.scrollHeight;
        body.style.height = '0px'; body.style.opacity = '0'; body.style.overflow = 'hidden';
        requestAnimationFrame(function () { body.style.transition = 'height .3s cubic-bezier(.22,.61,.36,1), opacity .3s'; body.style.height = h + 'px'; body.style.opacity = '1'; });
        setTimeout(clear, 320);
      }
    });
  });

  /* delivery check — estimates follow the published shipping policy; COD eligibility confirmed at checkout */
  var dl = d.querySelector('[data-kalank-delivery]');
  if (dl) {
    var pin = dl.querySelector('.KDelivery__Input'), out = dl.querySelector('.KDelivery__Result');
    try { var saved = localStorage.getItem('kalankPin'); if (saved) pin.value = saved; } catch (err) {}
    pin.addEventListener('input', function () { pin.value = pin.value.replace(/\D/g, '').slice(0, 6); });
    dl.querySelector('form').addEventListener('submit', function (e) {
      e.preventDefault(); var v = pin.value.replace(/\D/g, '');
      if (!/^[1-9][0-9]{5}$/.test(v)) { out.className = 'KDelivery__Result is-error'; out.textContent = 'Please enter a valid 6-digit PIN code.'; return; }
      try { localStorage.setItem('kalankPin', v); } catch (err) {}
      out.className = 'KDelivery__Result';
      /* Shipping policy: dispatch in 1-2 business days; metro cities 3-7, rest of India 7-10 business days from dispatch. */
      var metro = ['110', '121', '122', '201', '400', '560', '500', '600', '700', '411', '380'].indexOf(v.slice(0, 3)) > -1;
      out.innerHTML = '<strong>Estimated delivery to ' + v + ': about ' + (metro ? '4–9' : '8–12') + ' business days.</strong> Dispatched within 1–2 business days, then ' + (metro ? '3–7' : '7–10') + ' days in transit' + (metro ? ' to metro cities' : '') + '. Complimentary shipping. Cash-on-delivery eligibility is confirmed at checkout. <a href="/policies/shipping-policy">Shipping policy</a>';
    });
  }

  /* search: recent searches, loading state, keyboard navigation */
  if (sm) {
    var sInput = sm.querySelector('.Search__Input'), sRes = sm.querySelector('.Search__Results'), sSug = sm.querySelector('.KSearch__Suggest');
    var KEY = 'kalankRecentSearches';
    var readRecent = function () { try { return JSON.parse(localStorage.getItem(KEY) || '[]'); } catch (e) { return []; } };
    var saveRecent = function (q) { q = (q || '').trim(); if (q.length < 2) return; var list = readRecent().filter(function (x) { return x.toLowerCase() !== q.toLowerCase(); }); list.unshift(q); try { localStorage.setItem(KEY, JSON.stringify(list.slice(0, 5))); } catch (e) {} };
    var renderRecent = function () {
      var list = readRecent(), box = sm.querySelector('.KSearch__Recent');
      if (!sSug) return;
      if (!list.length) { if (box) box.remove(); return; }
      if (!box) { box = d.createElement('div'); box.className = 'KSearch__Recent'; sSug.firstElementChild.insertBefore(box, sSug.firstElementChild.firstChild); }
      box.innerHTML = '<p class="KSearch__Label">Recent searches <button type="button" class="KSearch__Clear">Clear</button></p><div class="KSearchChips">' + list.map(function (q) { var e = q.replace(/[&<>"]/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]; }); return '<a href="/search?type=product&q=' + encodeURIComponent(q) + '">' + e + '</a>'; }).join('') + '</div>';
      box.querySelector('.KSearch__Clear').addEventListener('click', function () { try { localStorage.removeItem(KEY); } catch (e) {} box.remove(); });
    };
    renderRecent();
    var sForm = sm.querySelector('form');
    if (sForm) sForm.addEventListener('submit', function () { saveRecent(sInput.value); });
    sm.addEventListener('click', function (e) { var a = e.target.closest('.KSearchItem, .KSearchRes__All'); if (a && sInput) saveRecent(sInput.value); });
    if (sInput && sRes) {
      sInput.addEventListener('input', function () { if (sInput.value.trim().length) sm.classList.add('is-loading'); else sm.classList.remove('is-loading'); });
      new MutationObserver(function () { sm.classList.remove('is-loading'); }).observe(sRes, { childList: true, subtree: true });
      sInput.addEventListener('keydown', function (e) {
        if (e.key !== 'ArrowDown') return; var first = sRes.querySelector('.KSearchItem'); if (first) { e.preventDefault(); first.focus(); }
      });
      sRes.addEventListener('keydown', function (e) {
        var items = Array.prototype.slice.call(sRes.querySelectorAll('.KSearchItem')), i = items.indexOf(d.activeElement);
        if (i < 0) return;
        if (e.key === 'ArrowDown') { e.preventDefault(); (items[i + 1] || items[i]).focus(); }
        if (e.key === 'ArrowUp') { e.preventDefault(); if (i === 0) sInput.focus(); else items[i - 1].focus(); }
      });
    }
  }

  /* add to bag: calm loading state on the main button */
  var atc = d.querySelector('.Product .ProductForm__AddToCart');
  if (atc) {
    var pform = atc.closest('form');
    if (pform) pform.addEventListener('submit', function () { atc.classList.add('is-busy'); setTimeout(function () { atc.classList.remove('is-busy'); }, 2500); });
    d.addEventListener('product:added', function () { atc.classList.remove('is-busy'); });
  }
})();
